import UUID from '../UUID';
import TextData from './TextData';
export default class {
  public constructor(
    readonly questionId: UUID,
    readonly selected: TextData[],
    readonly participantDefinedOption: string | null,
    readonly id: UUID | null = null
  ) {}
}
